import React, { PureComponent } from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';
import AppConstant from '../../../constants/app';
import ImageModal from './imageModal';

class BackgroundContent extends PureComponent {
  state = {
    currentBgImage: [],
    isModalActive: false,
  }
  
  componentDidMount () {
    this.fetchData();
  }

  fetchData = () => {
    axios.get(`${AppConstant.API_URL}/background`)
    .then(res => {
      const currentBgImage = res.data.background.image;
      this.setState({ currentBgImage });
    })
  }

  handleShow = () => {
    this.setState({ isModalActive: true });
  }

  render () {
    const {
      isModalActive,
    } = this.state;

    return (
      <Row className="image-bg">
        <Col sm={8}>
          <div className="text-right">
            <div
              className="edit-link"
            >
              <span
                onClick={this.handleShow}
              >
                Edit
              </span>
            </div>
          </div>
          <h2 className="image-bg-title">Image</h2>
          <img
            src={this.state.currentBgImage}
            alt=""
          />
          <ImageModal 
            isActive={isModalActive}
            onClose={() => {
              this.setState({ isModalActive: false });
            }}
            onFetchBackground={this.fetchData}
          />
        </Col>
      </Row>
    )
  }
}

export default BackgroundContent;


// WEBPACK FOOTER //
// ./src/app/screens/general/backgroundContent.js